import styled from 'styled-components';
import cssKit from '../../css';

export const StyledSliderWrapper = styled.div`
  &[aria-expanded=false] {
    .estimator-slider-button{
      margin: 0rem auto 1em auto;
    }
    .estimator-slider-content{
      overflow: hidden;
      max-height: 0;
      margin: 0px !important;
      padding: 0px !important;
    }
    .slider-title {
      display: block;
      text-align: center;
      padding-top: 1em;
    }
  }
`;

export const StyledSliderTitle = styled.span`
  display: none;
`;

export const StyledSliderButtonWrapper = styled.div`
  width: 100%;
  clear: both;
`;

export const StyledSliderContent = styled.div`
  transition: max-height 1s;

  .row {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const StyledEstimatorSliderButton = styled.button`
  outline: none;
  width: 1.5rem;
  height: 1.5rem;
  display: block;
  margin: 2rem auto 1em auto;

  ${cssKit.media.greaterThan('medium') `
    margin: 0 auto 1em auto;
  `};
`;

export const StyledOfferArrow = styled.span`
  position: relative;
  content: '';
  width: 1.125rem;
  height: 1.125rem;
  display: block;
  background: 0 0;
  border-top: solid 1px #000;
  border-left: solid 1px #000;
  transform: rotate(45deg) translate(-50%);
  pointer-events: none;
  left: 9px;
  top: 9px;
  padding: 0px;
  margin: 0px;

  &.closed {
    transform: rotate(225deg) translate(-50%);
    left: -9px;
    top: -9px;
  }
`;




/** WEBPACK FOOTER **
 ** ./src/components/Slider/styles.js
 **/